import fetch from 'cross-fetch';

export default class ApiService {
    constructor(bearerToken) {
        this.bearerToken = bearerToken;
        this.baseUri = process.env.API_URL + "/api/";
    }

    getAll = async (postfix) => {
        try {
            let response = await fetch(this.baseUri + postfix, {
                method: 'GET',
                
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.bearerToken
                }
            });
            if (!response.ok) {
                throw new Error(response.statusText);
            }

            let body = await response.json();
            return body;

        } catch (err) {
            console.error(err)
            throw (err);
        }
    }

    createNew = async (postfix, data) => {

        const url = this.baseUri + postfix;
        try {
            let response = await fetch(url, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.bearerToken
                }
            });
            if (!response.ok) {
                throw new Error(response.statusText);
            }

            let body = await response.json(); // or .json() or whatever
            return body;

        } catch (err) {
            console.error(err)
            throw (err);
        }
    }

    edit = async (postfix, data) => {

        const url = this.baseUri + postfix + '/' + data.id;
        try {
            let response = await fetch(url, {
                method: 'PUT',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.bearerToken
                }
            });
            if (!response.ok) {
                throw new Error(response.statusText);
            }

            let body = await response.json(); // or .json() or whatever
            return body;

        } catch (err) {
            console.error(err)
            throw (err);
        }
    }

    delete = async (postfix, data) => {

      const url = this.baseUri + postfix + '/' + data.id;

      try {
        let request = await fetch(url, {
          method: 'DELETE',
          body: JSON.stringify({}),
          headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.bearerToken
          }
        });

        if (!request.ok) {
          const error = await request.text();
          throw error;
        } else {
          const response = await request.json();
          return response;

        }
      }

      catch (ex) {
        console.error(ex);
        throw Error(ex);
      }

    }
}



// WEBPACK FOOTER //
// ./src/services/api.js